<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="cleaningForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                cleaningForm: () => import('../forms/CleaningForm'),
                headers: [
                    { text: 'Facility', value: 'facilityId', table: 'facilities', form: () => import('../forms/FacilityForm') },
                    { text: 'Cleaned On', value: 'cleanedOn', format: this.formatDate },
                    { text: 'Staff Member', value: 'staffMemberId', table: 'staffMembers', form: () => import('../forms/StaffMemberForm') },
                    { text: 'Harvesting', value: 'harvestingId', table: 'harvestings', form: () => import('../forms/HarvestingForm') },
                    { text: 'Report File', value: 'reportFileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    facilities: [],
                    harvestings: [],
                    files: [],
                    staffMembers: [],
                    items: []
                },
                sorting: [
                    { column: "cleanedOn", direction: "descending" },
                    { column: "facilityId", direction: "ascending" },
                    { column: "staffMemberId", direction: "ascending" },
                ],
                itemsField: 'cleanings',
                editPageName: 'cleaning',
                apiMethod: 'Cleanings',
                claimName: 'Cleanings',
                formTitle: 'Cleaning',
                excelTitle: 'Cleanings',
                hasEditPage: false,
            }
        },
    };
</script>
